import { getDurationOfHlsFromManifest } from './duration-from-hls';

export const getVideoDuration = async (mediaUrl: string, mediaType: string, paramVideo: HTMLVideoElement) => {
  const video = paramVideo;

  const returnedDuration: number = await new Promise<number>((resolve, reject) => {
    try {
      if (mediaType === 'hls' || mediaUrl.endsWith('.m3u8')) {
        getDurationOfHlsFromManifest(mediaUrl).then(resolve).catch(reject);
      } else {
        video.onloadedmetadata = () => {
          const duration = video.duration || 0;
          window.URL.revokeObjectURL(video.src);
          resolve(duration);
        };

        video.src = mediaUrl;
      }
    } catch (e) {
      // weird interaction where e can't be Error type
      console.error('getVideoDuration failed', { error: e });
      reject(e);
    }
  });

  return returnedDuration;
};

export default getVideoDuration;
